const escapeCsv = (value) => {
  const text = String(value ?? "");
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const formatAmount = (value) =>
  value == null || value === "" ? "0.00" : Number(value).toFixed(2);

export const defaultPeriodEndDate = (periodEndDate) => {
  if (!periodEndDate) return null;
  const end = new Date(periodEndDate);
  const today = new Date();
  end.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  return end < today ? end : today;
};

export const formatDateLabel = (date) =>
  date ? new Date(date).toLocaleDateString() : "";

const downloadCsv = (lines, filename) => {
  const csv = `\uFEFF${lines.map((line) => line.map(escapeCsv).join(",")).join("\n")}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const downloadProfitAndLossCsv = ({
  report,
  periodName = "",
  startDate = null,
  endDate = null,
  t,
}) => {
  const lines = [
    [t("accounting.financialStatements.pnlTitle")],
    [
      t("Fiscal Period"),
      periodName,
      t("accounting.financialStatements.pnlFrom"),
      formatDateLabel(startDate),
      t("accounting.financialStatements.pnlTo"),
      formatDateLabel(endDate),
    ],
    [],
    [t("Code"), t("accounting.journal.account"), t("Amount")],
    [t("accounting.financialStatements.revenue")],
    ...(report?.revenue || []).map((row) => [row.code, row.name, formatAmount(row.amount)]),
    [
      t("accounting.financialStatements.totalRevenue"),
      "",
      formatAmount(report?.totalRevenue),
    ],
    [],
    [t("accounting.financialStatements.expenses")],
    ...(report?.expenses || []).map((row) => [row.code, row.name, formatAmount(row.amount)]),
    [
      t("accounting.financialStatements.totalExpenses"),
      "",
      formatAmount(report?.totalExpenses),
    ],
    [],
    [
      t("accounting.financialStatements.netProfit"),
      "",
      formatAmount(report?.netProfit),
    ],
  ];

  const stamp = new Date().toISOString().slice(0, 10);
  downloadCsv(lines, `profit-and-loss-${periodName || stamp}.csv`);
};

export const downloadBalanceSheetCsv = ({
  report,
  periodName = "",
  bsAsOfDate = null,
  t,
}) => {
  const lines = [
    [t("accounting.financialStatements.bsTitle")],
    [
      t("Fiscal Period"),
      periodName,
      t("accounting.financialStatements.bsAsOf"),
      formatDateLabel(bsAsOfDate),
    ],
    [],
    [t("Code"), t("accounting.journal.account"), t("Amount")],
    [t("accounting.financialStatements.assets")],
    ...(report?.assets || []).map((row) => [row.code, row.name, formatAmount(row.amount)]),
    [
      t("accounting.financialStatements.totalAssets"),
      "",
      formatAmount(report?.totalAssets),
    ],
    [],
    [t("accounting.financialStatements.liabilities")],
    ...(report?.liabilities || []).map((row) => [
      row.code,
      row.name,
      formatAmount(row.amount),
    ]),
    [
      t("accounting.financialStatements.totalLiabilities"),
      "",
      formatAmount(report?.totalLiabilities),
    ],
    [],
    [t("accounting.financialStatements.equity")],
    ...(report?.equity || []).map((row) => [row.code, row.name, formatAmount(row.amount)]),
    [
      t("accounting.financialStatements.totalEquity"),
      "",
      formatAmount(report?.totalEquity),
    ],
    [],
    [
      t("accounting.financialStatements.totalLiabilitiesAndEquity"),
      "",
      formatAmount(report?.totalLiabilitiesAndEquity),
    ],
  ];

  const stamp = new Date().toISOString().slice(0, 10);
  downloadCsv(lines, `balance-sheet-${periodName || stamp}.csv`);
};

export const hasPnlActivity = (report) =>
  Boolean(
    report &&
      ((report.revenue || []).length > 0 || (report.expenses || []).length > 0)
  );

export const hasBalanceSheetActivity = (report) =>
  Boolean(
    report &&
      ((report.assets || []).length > 0 ||
        (report.liabilities || []).length > 0 ||
        (report.equity || []).length > 0)
  );
